var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-container',{staticClass:"fill-height align-start",class:_vm.isMobile ? 'mx-0 px-0' : '',staticStyle:{"overflow-x":"auto"},attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.path})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }